<template>
  <VMenu open-on-hover bottom offset-y content-class="elevation-2" style="z-index: 999 !important;">
    <template #activator="{ on }">
      <slot name="activator" :on="on">
        <BaseButton v-on="on">
          {{ title }}
        </BaseButton>
      </slot>
    </template>

    <VList :class="menuClass">
      <WithLayouts v-slot="{ layouts }" :location="location">
        <div class="layouts-dropdown">
          <VListTile
            v-for="(layout, index) in digitalLayouts(layouts)"
            :key="index"
            :to="layout.slug !== currentLayoutSlug ? { path: `/locations/${location.slug}/layouts/${layout.slug}`, query } : undefined"
            :disabled="layout.slug === currentLayoutSlug"
          >
            <VListTileContent>
              <VListTileTitle class="ml-2">{{ layout.title }}</VListTileTitle>
            </VListTileContent>
            <VListTileAction v-if="layout.slug === currentLayoutSlug">
              <VIcon small color="blue darken-2">check</VIcon>
            </VListTileAction>
          </VListTile>
        </div>
      </WithLayouts>
    </VList>
  </VMenu>
</template>

<script>
import WithLayouts from '@dataProviders/WithLayouts.vue'

export default {
  name: 'BaseLocationLayoutsMenu',
  components: {
    WithLayouts,
  },
  props: {
    title: {
      type: String,
      default: 'View Digital Menus',
    },
    menuClass: {
      type: String,
      default: '',
    },
    location: {
      type: Object,
      required: true,
    },
    query: {
      type: Object,
      default: () => ({}),
    },
    currentLayoutSlug: {
      type: String,
      default: null,
    },
  },
  methods: {
    digitalLayouts(layouts) {
      if (!layouts || !Array.isArray(layouts)) return []
      return layouts.filter((layout) => layout.type === 'digital')
    },
  },
}
</script>

<style scoped>
</style>
